import { render, staticRenderFns } from "./DashboardCall.vue?vue&type=template&id=14d79055"
import script from "./DashboardCall.vue?vue&type=script&lang=js"
export * from "./DashboardCall.vue?vue&type=script&lang=js"
import style0 from "./DashboardCall.vue?vue&type=style&index=0&id=14d79055&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports